<template>
  <tr class="font-weight-bold">
    <template v-if="!file.created_by && (file.active || file.progress !== '0.00')">
      <td>
        <a href="javascript:;" target="_blank" class="d-flex align-items-center">
          <font-awesome-icon :icon="getFileIcon(file)" style="font-size: 30px; width:30px" class="mr-3"></font-awesome-icon>
          {{ file.custom_name || file.name }}
        </a>
      </td>
      <td>{{ file.size | formatSize }}</td>
      <td>
        <div style="line-height: 0.9em">
          <span v-if="file.error" class="text-danger">failed</span>
          <span v-if="file.success">success</span>
          <span v-else-if="file.active">uploading...</span>
        </div>
      </td>
      <td colspan="3" class="py-0">
        <span v-if="file.error" class="text-danger">{{ (file.response && file.response.url) || file.error }}</span>
        <div v-else class="progress mt-1">
          <div :class="{
            'progress-bar': true,
            'bg-primary': file.success,
            'bg-danger': file.error,
            'progress-bar-animated': file.active,
          }" role="progressbar" :style="{ width: file.progress + '%' }">
            {{  file.progress + '%' }}
          </div>
        </div>
      </td>
    </template>
    <template v-else>
      <td>
        <div class="d-flex align-items-center">
          <a :href="fileUrl" target="_blank" class="mr-3">
            <secure-img v-if="imgUrl" :url="imgUrl" style="width:30px; min-width:30px" @resolved="(e) => (imageResolvedUrl = e)" />
            <span v-else>
              <font-awesome-icon :icon="getFileIcon(file)" style="font-size: 30px; width:30px; " class="d-block"></font-awesome-icon>
            </span>
          </a>
          <div v-if="file.url" class="text-overflow" style="max-width: 100px">
            <template v-if="!isEditingName">
              <a :href="fileUrl" target="_blank">{{ file.custom_name || file.name }}</a>
              <a href="javascript:;" class="pl-2" @click="isEditingName=true; $nextTick(()=>$refs.customName.focus())">
                <font-awesome-icon class="text-muted" :icon="['far', 'edit']" />
              </a></template>
            <template v-else>
              <div class="d-flex align-items-center">
                <div class="input-group">
                  <input v-model="customName" ref="customName" @keydown.enter="updateFile" @focus="$event.target.select()" type="text" class="form-control" placeholder="File name">
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="button" @click="updateFile">
                      <font-awesome-icon v-if="isSavingFile" icon="spinner-third" class="" spin /><span v-else>Save</span>
                    </button>
                  </div>
                </div>
                <small class="ml-2"><a href="javascript:;" @click="isEditingName=false" class="text-nowrap">cancel</a></small>
              </div>
            </template>
          </div>
        </div>
      </td>
      <td>{{ file.size | formatSize }}</td>
      <td>
        {{ moment(file.created_at).fromNow() }}
      </td>
      <td>
        <div class="form-check text-left pl-0">
          <div class="custom-control custom-switch">
            <input v-model="isXray" type="checkbox" class="custom-control-input" name="is_xray" :id="`xraySwitch${file.id}`" @change="updateFile" />
            <label class="custom-control-label text-nowrap" :for="`xraySwitch${file.id}`">Is X-Ray</label>
          </div>
        </div>
        <!-- <select class="form-control" style="width:150px" @change="updateFile" v-model="file.document_type">
          <option value="0">General</option>
          <option value="1">X-Ray</option>
          <option value="2">Report</option>
          <option value="3">Patient</option>
        </select> -->
      </td>
      <td>
        <div class="d-flex align-items-center justify-content-end" v-if="file && file.updated_at" style="width:120px">
          <span v-if="file.item_date" class="mr-2 text-nowrap flex-grow-1">
            {{ moment(file.item_date).format('ll') }}
          </span>
          <span v-else class="mr-2 text-nowrap text-muted flex-grow-1">
            No date set
          </span>
          <VueCtkDateTimePicker v-model="file.item_date" :format="'YYYY-MM-DD HH:mm'" class="d-inline text-right slim-time-picker" :no-value-to-custom-elem="true" :no-button-now="true" :max-date="moment().toISOString()" color="#519F85" :only-date="true" @validate="updateFile">
            <slot>
              <button type="button" class="btn p-0 btn-link d-inline" :disabled="isSavingFile">
                <font-awesome-icon :icon="isSavingFile ? 'spinner-third' : ['far', 'calendar']" class="" :spin="isSavingFile" />
              </button>
            </slot>
          </VueCtkDateTimePicker>
          <div>
          </div>
        </div>
      </td>
      <td>
        <a class href="javascript:void(0);" @click.prevent.stop="onDeleteClick(file)" :disabled="isDeleting">
          <font-awesome-icon icon="spinner-third" v-if="isDeleting" spin />
          <font-awesome-icon :icon="['far', 'trash']" v-else />
        </a>
      </td>
    </template>
  </tr>
</template>

<script>
import { AttachmentApi } from '@/services'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import Vue from 'vue'
import SecureImg from './SecureImg.vue'

export default {
  props: ['file'],
  data() {
    return {
      isSavingFile: false,
      customName: this.file.custom_name,
      imageResolvedUrl: null,
      isEditingName: false,
      isDeleting: false,
      isXray: this.file.document_type == 1,
    }
  },
  mounted() {},
  computed: {
    imgUrl() {
      return this.getImageFile(this.file)
    },
    fileUrl() {
      return this.imgUrl
        ? this.imageResolvedUrl
        : this.$helpers.cdnUrl(this.file.url)
    },
  },
  components: {
    VueCtkDateTimePicker,
    SecureImg,
  },
  methods: {
    getFileIcon: function (file) {
      if (!file) return
      if (file.type && file.type.toLowerCase().startsWith('image'))
        return 'file-image'
      const extension = file.name && file.name.split('.').pop()
      switch ((extension || '').toLowerCase()) {
        case 'pdf':
          return 'file-pdf'
        case 'jpg':
        case 'jfif':
        case 'gif':
        case 'jpeg':
        case 'png':
        case 'svg':
          return 'file-image'
      }
      return 'file'
    },
    getImageFile: function (file) {
      if (!file) return
      if (file.thumb) return file.thumb
      if (!file.updated_at) return
      if (file.type && file.type.toLowerCase().startsWith('image'))
        return file.file || (file.url && this.$helpers.cdnUrl(file.url)) || ''
      const extension = file.name && file.name.split('.').pop()
      switch ((extension || '').toLowerCase()) {
        case 'jpg':
        case 'gif':
        case 'jpeg':
        case 'png':
        case 'svg':
          return this.$helpers.cdnUrl(file.url)
      }
      return false
    },
    inputFile: function (newFile, oldFile) {
      if (newFile && !newFile.active) {
        newFile.active = true
        if (newFile && oldFile && newFile.success !== oldFile.success) {
          this.completedUploads = [newFile.response, ...this.completedUploads]
        }
      }
    },
    async updateFile() {
      this.isSavingFile = true
      this.file.custom_name = this.customName
      await AttachmentApi.patch(this.file.id, {
        item_date: this.file.item_date,
        custom_name: this.file.custom_name,
        document_type: this.isXray ? 1 : 0,
      })
      this.isSavingFile = false
      this.isEditingName = false
    },
    onDeleteClick() {
      const _this = this
      this.$dialog
        .confirm(
          {
            title: 'Confirm Delete',
            body: 'Are you sure you want to delete this upload?',
          },
          { okText: 'Yes', cancelText: 'No' }
        )
        .then(async () => {
          _this.isDeleting = true
          await AttachmentApi.delete(_this.file.id)
          _this.isDeleting = false
          _this.$emit('deleted', _this.file.id)
        })
    },
  },
}
</script>
<style scoped>
.as-link {
  cursor: pointer;
}

.max-100 img {
  max-width: 100%;
  max-height: 100%;
}
</style>
